import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import Modal from '../../components/2d/modal/Modal'
import {
    hotspotModalVideoEnded,
    hotspotModalVideoPlay,
    hotspotModalVideoPause,
    hotspotModalVideoDragEnd,
} from '../../actions/hotspotModalActions'
import { TextPlayer } from 'aria-viewer/common/components/TextPlayer'
import VideoPlayer from '../../components/2d/player/VideoPlayer.jsx'
import 'videojs-youtube'
import { setVisited, closeModal, forceMediaPause, setDragHintDetails } from '../../actions/common.js'
import { lookupElement } from '../../methods/lookupElement'
import React from 'react'
import classNames from 'classnames'
import compose from 'recompose/compose'
import { PanoramaSizes } from 'aria-viewer/players'
import { WithEventListener } from 'aria-viewer/common'
import { onetrust } from 'aria-viewer/core/analyticsManager'
import YouTubeIframe from 'aria-viewer/interactive-element/components/2d/player/YouTubeIframe'
import { KEY_CODES, VIDEO_TYPE } from 'aria-viewer/tour/constants/index'
import { stopAudio, AUDIO_HS } from 'aria-viewer/audiomanager/audioManagerActions'
import PhotoViewer from '../../components/2d/PhotoViewer'
import MediaCarousel from '../../components/2d/MediaCarousel'
import DraggingHint from '../common/DraggingHint'
import { WithAnimation } from 'aria-viewer/common'
import UriHandler from 'aria-viewer/utils/uriHandler'
import SlimPanoPlayerWrapper from 'aria-viewer/players/panoplayer/containers/slimPanoPlayerWrapper'
import SimpleVideoPlayerWrapper from 'aria-viewer/players/videoplayer/containers/simpleVideoPlayerWrapper'

require('!style-loader!css-loader!video.js/dist/video-js.css')

const styleSheet = (theme, props) => ({
    videoContainer: {
        height: ({ isMobile }) => (isMobile ? 518 : null),
        '@media (orientation: landscape)': {
            height: ({ isMobile }) => (isMobile ? '100vh' : null),
        },
    },
    panoContainer: {
        height: '100%',
        '& div:first-child': {
            // Have to tag as important to override aria-ui
            height: '100% !important',
        },
        '& div': {
            width: ({ viewportWidth }) => {
                return viewportWidth - 80
                // return (mediaItem.item_type === 'panorama' && !isMobile) ? viewportWidth-80 : null
            },
            height: '100%',
            '& canvas': {
                width: '100%',
                height: '100%',
            },
            '& div': {
                paddingLeft: ({ isMobile }) => (isMobile ? null : '36px'),
                paddingBottom: ({ isMobile }) => (isMobile ? null : '32px'),
                boxSizing: 'border-box',
            },
        },
    },
    panoMobileOverride: {
        '& div': {
            width: 'auto !important',
            // Have to tag as important to override aria-ui
            height: 'auto !important',
            '& canvas': {
                height: '100%',
            },
        },
    },
    slide: {
        maxHeight: 515,
        maxWidth: 920,
        objectFit: 'contain',
    },
    animationContainer: {
        zIndex: 3000,
    },
    panoTitleDescriptionContainer: {
        color: 'white',
        background: 'linear-gradient(to top, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0))',
        pointerEvents: 'none',
    },
    panoTitle: {
        fontSize: '36px',
        lineHeight: '46px',
        fontWeight: '500',
        margin: 0,
        textShadow: '0 6px 20px rgba(0, 0, 0, 0.4), 0 2px 4px rgba(0, 0, 0, 0.5)',
        '& > p > a': {
            color: 'white',
            textDecoration: 'underline',
            '&:hover': {
                textDecorationColor: 'blue',
            },
        },
    },
    panoDescription: {
        fontSize: '15px',
        lineHeight: '22px',
        textShadow: '0 2px 4px rgba(0, 0, 0, 0.5)',
        '& > p > a': {
            color: 'white',
            textDecoration: 'underline',
            pointerEvents: 'all',
            '&:hover': {
                textDecorationColor: 'blue',
            },
        },
    },
})

const style = injectSheet(styleSheet)

const getHotSpotURL = (mediaItem, type, state) => {
    switch (type) {
        case 'video':
        case '360 video': {
            const id = mediaItem.videoMedia[0]
            const video = lookupElement({ id, type: 'videoMedia', state })

            if (VIDEO_TYPE.AWS == mediaItem.type) {
                return video
                    .get('renditions')
                    .get(0)
                    .get('url')
            } else if (VIDEO_TYPE.YOUTUBE == mediaItem.type) {
                return mediaItem.external_url
            } else if (VIDEO_TYPE.VIMEO == mediaItem.type) {
                return `https://player.vimeo.com/video/${id}?api=1&title=0&portrait=0&byline=0&badge=0&loop=0&share=0`
            } else {
                return video.get('url')
            }
        }
        case 'panorama':
            return mediaItem.mediumurl
        default:
            return null
    }
}

const getPanoramaURL = (mediaItem, size = PanoramaSizes.SIZE_4096) => `${mediaItem.external_url}${size}.jpg`

const mapStateToProps = state => {
    const { type, id, mediaType, mediaId } = state.getIn(['interactiveElements', 'modal'])
    const hotspotCoordinates = state.getIn(['interactiveElements', 'hotspotCoordinates'])

    if (id) {
        const viewportWidth = state.getIn(['device', 'viewportWidth'])
        const viewportHeight = state.getIn(['device', 'viewportHeight'])
        const isLandscape = state.getIn(['device', 'isLandscape'])
        const isMobile = state.getIn(['device', 'isDeviceMobile']) !== null
        const isTablet = state.getIn(['device', 'isDeviceTablet']) !== null
        const isGyroscopeEnabled = state.getIn(['device', 'isGyroscopeEnabled'])
        const { mediaItems, title, description } = lookupElement({ type, id, state, toJS: true })
        const mediaItem = lookupElement({ type: 'mediaItems', id: mediaId, state, toJS: true })
        const itemType = mediaType || mediaItem.item_type
        const hotspotUrl = getHotSpotURL(mediaItem, itemType, state)
        const url = hotspotUrl && UriHandler.appendCorsQueryParam(hotspotUrl)
        const { start_fov: fov } = state.getIn(['interactiveElements', 'currentScene', 'scene'])
        const largeUrl = mediaItem.largeurl
        const isDraggingHintVisible = state.getIn(['interactiveElements', 'draggingHint', 'isVisible'])

        return {
            mediaItems,
            mediaItem,
            id,
            type: itemType,
            title: title,
            description: description,
            url,
            largeUrl,
            state,
            elementType: type,
            viewportWidth,
            viewportHeight,
            fov,
            isMobile,
            isTablet,
            isDraggingHintVisible,
            hotspotCoordinates,
            isGyroscopeEnabled,
            isLandscape,
        }
    } else {
        return {
            hotspotCoordinates,
        }
    }
}

const stopProps = function(Component) {
    return class extends React.Component {
        shouldComponentUpdate({ id: newId }) {
            return newId === this.props.id
        }
        render() {
            return <Component {...this.props} />
        }
    }
}

const buildPlayer = Component => ({ state, ...props }) => {
    let player = null

    let isFullWidthTitleDescription
    if (props.viewportWidth >= 1024) {
        isFullWidthTitleDescription = false
    } else if (props.viewportWidth < 1024 && props.viewportWidth >= 768) {
        isFullWidthTitleDescription = true
    } else {
        isFullWidthTitleDescription = true
    }

    switch (props.type) {
        case 'photo': {
            const { mediaItems, title: hotspotTitle, description: hotspotDescription, classes, isMobile } = props

            const mediaList = mediaItems.map(id => {
                const { external_url, title, description } = lookupElement({
                    id,
                    type: 'mediaItems',
                    state,
                    toJS: true,
                })

                return {
                    player: () => <PhotoViewer src={external_url} maxWidth={920} maxHeight={515} isMobile={isMobile} />,
                    title: title.length > 0 ? title : hotspotTitle,
                    description: description.length > 0 ? description : hotspotDescription,
                }
            })

            const render = ({ player }) => player()
            player = (
                <MediaCarousel
                    {...{ render, mediaList }}
                    slideClassName={classes.slide}
                    borderless={false}
                    isMobile={isMobile}
                    isFullWidthTitleDescription={isFullWidthTitleDescription}
                />
            )
            break
        }

        case 'text': {
            const { title, description } = props
            player = <TextPlayer title={title} description={description} />
            break
        }

        case 'video': {
            const {
                isMobile,
                classes,
                mediaItem,
                url,
                largeUrl,
                title,
                description,
                onEnded,
                onPause,
                onPlay,
                onClose,
            } = props

            const shouldUseYouTubeNoCookie = mediaItem.type === 'youtube'

            // Wrap VideoPlayer inside MediaCarousel component when the description is present
            if (description.length > 0) {
                const mediaList = [
                    {
                        player: () =>
                            shouldUseYouTubeNoCookie ? (
                                <YouTubeIframe videoId={mediaItem.videoid} height={isMobile ? '500px' : '100%'} />
                            ) : (
                                <VideoPlayer
                                    className={classes.videoContainer}
                                    src={url}
                                    poster={largeUrl}
                                    media_type="video"
                                    title={title}
                                    type={mediaItem.type}
                                    captionOptions={[]}
                                    backToScene={onClose}
                                    onEnded={onEnded}
                                    onPlay={onPlay}
                                    onPause={onPause}
                                    media_is360={false}
                                    enableTitle={false}
                                />
                            ),
                        title,
                        description,
                    },
                ]

                player = (
                    <MediaCarousel
                        render={({ player }) => player()}
                        mediaList={mediaList}
                        borderless={false}
                        isMobile={isMobile}
                        justifyCarouselContent="center"
                        isFullWidthTitleDescription={isFullWidthTitleDescription}
                    />
                )
            } else {
                player = shouldUseYouTubeNoCookie ? (
                    <YouTubeIframe videoId={mediaItem.videoid} height={isMobile ? '500px' : '100%'} />
                ) : (
                    <VideoPlayer
                        src={url}
                        poster={largeUrl}
                        media_type="video"
                        title={title}
                        type={mediaItem.type}
                        captionOptions={[]}
                        backToScene={onClose}
                        onEnded={onEnded}
                        onPlay={onPlay}
                        onPause={onPause}
                        media_is360={false}
                    />
                )
            }
            break
        }

        case 'panorama': {
            const { mediaItem, title, description, classes, isGyroscopeEnabled, isLandscape, isMobile } = props
            const options = {
                alt: mediaItem.meta2,
                hasEasy: 1,
                height: window.innerHeight,
                hitTimeout: 5000,
                id: mediaItem.id,
                loc_id: mediaItem.item_id,
                mediaType: 'panorama',
                path: mediaItem.external_url,
                priority: 1,
                showFullscreen: false,
                showRotate: false,
                startFov: 100,
                startLat: null,
                startLon: null,
                start_fov: null,
                start_lat: 0,
                start_lon: 180,
                stopid: mediaItem.item_id,
                urls: {
                    tiny: mediaItem.smallurl,
                    small: mediaItem.smallurl,
                    medium: mediaItem.mediumurl,
                    large: mediaItem.external_url,
                },
                width: props.viewportWidth,
                accelerometerControls: isGyroscopeEnabled,
            }

            player = (
                <SlimPanoPlayerWrapper
                    options={options}
                    title={title}
                    description={description}
                    isLandscape={isLandscape}
                    isMobile={isMobile}
                >
                    <div className={classNames(classes.panoTitleDescriptionContainer, 'panoTitleDescriptionContainer')}>
                        <h1 className={classes.panoTitle} dangerouslySetInnerHTML={{ __html: title }} />
                        <p className={classes.panoDescription} dangerouslySetInnerHTML={{ __html: description }} />
                    </div>
                </SlimPanoPlayerWrapper>
            )
            break
        }

        case '360 video': {
            const {
                mediaItem,
                url,
                largeUrl,
                isMobile,
                onClose,
                onPlay,
                title,
                onEnded,
                onDragEnd,
                onDragStart,
                onPause,
                fov = 100,
                isGyroscopeEnabled,
            } = props
            const options = {
                accessPlayerAPI: true,
                alt: 'media',
                autoplay: true,
                category: '',
                description: '',
                disableShowDragHintOnLoad: true,
                duration: 118,
                hideUI: true,
                id: mediaItem.item_id,
                largeurl: largeUrl,
                mediumurl: mediaItem.mediumurl,
                loc_id: mediaItem.item_id,
                mediaType: url,
                projection: 'equirectangular',
                projectionPriority: ['equirectangular', 'easy'],
                stereo_360: '',
                url,
                videoid: mediaItem.videoid,
                videoId: mediaItem.videoid,
                type: 'aws',
                playback_type: '360',
                accelerometerControls: isGyroscopeEnabled,
            }

            player = isMobile ? (
                <SimpleVideoPlayerWrapper isFromModal={false} options={options} />
            ) : (
                <VideoPlayer
                    autoPlay={true}
                    src={url}
                    fov={fov}
                    poster={largeUrl}
                    media_type="pano"
                    title={title}
                    type={mediaItem.type}
                    captionOptions={[]}
                    backToScene={onClose}
                    onEnded={onEnded}
                    onPlay={onPlay}
                    onPause={onPause}
                    onDragEnd={onDragEnd}
                    onDragStart={onDragStart}
                    media_is360={true}
                    isMobile={isMobile}
                />
            )
        }
    }

    return <Component {...{ ...props, Player: () => player }} />
}

const mapDispatchToProps = dispatch => ({
    closeModal: ({ id, type, mediaType }) => {
        dispatch(setVisited({ id, type }))
        dispatch(stopAudio(AUDIO_HS)) // deregister audio
        dispatch(forceMediaPause(false))
        dispatch(closeModal({ id, type, mediaType }))
    },

    onEnded: () => {
        dispatch(hotspotModalVideoEnded())
    },

    onPlay: () => {
        dispatch(hotspotModalVideoPlay())
    },

    onPause: () => {
        dispatch(hotspotModalVideoPause())
    },

    onDragEnd: () => {
        dispatch(hotspotModalVideoDragEnd())
    },

    hideDraggingHint: () => {
        dispatch(setDragHintDetails({ isVisible: false }))
    },
})

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    onClose: () => {
        const { closeModal } = dispatchProps
        const { id, elementType, type } = stateProps

        closeModal({ id, type: elementType, mediaType: type })
    },

    onDragStart: () => {
        if (stateProps.isDraggingHintVisible) dispatchProps.hideDraggingHint()
    },
})

export default compose(
    connect(mapStateToProps, mapDispatchToProps, mergeProps),
    style,
    WithAnimation({
        className: ({ classes }) => classes.animationContainer,

        show: ({ id }) => (id ? true : false),

        start: {
            opacity: 0,
        },

        enter: {
            opacity: [1],
            timing: { duration: 750 },
        },

        update: {
            opacity: [1],
            timing: { duration: 750 },
        },

        leave: {
            opacity: [0],
            timing: { duration: 750 },
        },
    }),
    stopProps,
    buildPlayer,
    WithEventListener({
        target: document,
        onKeyDown: props => e => {
            if (e.which == KEY_CODES.ESCAPE) {
                const { id, closeModal, elementType, type } = props

                closeModal({ id, type: elementType, mediaType: type })
            }
        },
    })
)(Modal)
